import { useResize } from '@hooks/useResize';
import { unit } from '@lib/style/unit';
import { updateGoSquaredPosition } from '@packages/common/lib/goSquared';
import { PAGE_HEADER_THEME } from '@packages/layout/lib/PageHeader/theme';
import { FixedMountPoint, FixedMountPointProps } from '@packages/portals/lib/FixedMountPoint';
import { handleResizePoint } from '@packages/portals/lib/utils';
import { createMemo } from '@packages/react';
import React from 'react';

export const FooterMountPoint = createMemo<Omit<FixedMountPointProps, 'name'>, { POINT: string }>(
    (props) => {
        useResize(
            handleResizePoint(FooterMountPoint.POINT, {
                readProp: 'clientHeight',
                writeProp: (value, writeElement) => (writeElement.style.paddingBottom = `${unit(value)}`),
                after({ portal }) {
                    updateGoSquaredPosition(portal.clientHeight);
                },
            }),
        );

        return (
            <FixedMountPoint
                name={FooterMountPoint.POINT}
                bottom={0}
                l={0}
                r={0}
                z={PAGE_HEADER_THEME.get('zIndex')}
                {...props}
            />
        );
    },
    {
        displayName: 'FooterMountPoint',
        POINT: 'layout-footer',
    },
);
